var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10005 4.32382C7.14857 3.86016 6.07969 3.60001 4.95005 3.60001C3.82041 3.60001 2.75153 3.86016 1.80005 4.32382V13.3238C2.75153 12.8602 3.82041 12.6 4.95005 12.6C6.45179 12.6 7.84615 13.0598 9.00005 13.8462C10.1539 13.0598 11.5483 12.6 13.05 12.6C14.1797 12.6 15.2486 12.8602 16.2 13.3238V4.32382C15.2486 3.86016 14.1797 3.60001 13.05 3.60001C11.9204 3.60001 10.8515 3.86016 9.90005 4.32382V10.8C9.90005 11.2971 9.49711 11.7 9.00005 11.7C8.50299 11.7 8.10005 11.2971 8.10005 10.8V4.32382Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.c7666a6a5eb43514b273b344066d7917.svg";
export { ForwardRef as ReactComponent };